/* ---------------------------------------------------------------------------
   Ir cargando la biblioteca al bajar.

   Las primeras páginas se abren solas y después aparece un botón. El freno no
   es pereza: con quinientas tarjetas en pantalla el móvil va a tirones, y un
   desplazamiento que nunca acaba deja el pie de página inalcanzable —donde
   están los avisos legales y el contacto—.

   La paginación de verdad sigue existiendo en el HTML y de ahí sale la
   dirección de la página siguiente. Eso es lo que permite que Google recorra
   las 2.556 piezas saltando de página en página: un desplazamiento infinito
   que se inventa las direcciones esconde medio catálogo.

   Sin este fichero se ven los botones de siempre y se pasa de página a mano.
   Ninguna pieza deja de ser alcanzable.
   --------------------------------------------------------------------------- */
// Se arranca tambien despues de filtrar: al cambiar los filtros la rejilla se
// repinta entera y con ella desaparecen el boton y la paginacion a los que
// estaba enganchado esto. Sin volver a arrancar, la biblioteca filtrada se
// quedaba en las primeras cincuenta piezas sin manera de seguir bajando.
const lvArrancaMas = () => {
  const rejilla = document.querySelector('[data-lv-rejilla]');
  const nav = document.querySelector('[data-lv-paginacion]');
  const caja = document.querySelector('[data-lv-mas]');
  if (!rejilla || !nav || !caja) return;

  const boton = caja.querySelector('[data-lv-mas-boton]');
  const nota = caja.querySelector('[data-lv-mas-nota]');

  // A partir de aquí manda el JavaScript: el botón sustituye a «Newer» y
  // «Older», pero LOS NÚMEROS DE PÁGINA SE QUEDAN. Esconder la paginación
  // entera dejaba la biblioteca sin vuelta atrás: con 77 páginas, quien baja
  // veinte minutos no tiene forma de volver al principio (22-09-2026).
  const flechas = nav.querySelectorAll('[data-lv-anterior], [data-lv-siguiente]');
  flechas.forEach((e) => { e.hidden = true; });
  caja.hidden = false;

  let siguiente = nav.querySelector('[data-lv-siguiente]')?.href || null;
  let solasRestantes = Number(nav.dataset.lvAuto || 0);
  let cargando = false;

  // Un rotulo de coleccion sale la PRIMERA vez que aparece esa coleccion. Cada
  // hoja se genera sin saber nada de las otras, asi que al pegar hojas —por
  // abajo o por arriba— pueden salir dos del mismo nombre. Esto deja solo el
  // primero que haya en la rejilla, que es donde toca.
  const quitaRotulosRepetidos = () => {
    const vistas = new Set();
    rejilla.querySelectorAll('[data-lv-coleccion]').forEach((el) => {
      const col = el.dataset.lvColeccion;
      if (vistas.has(col)) el.remove();
      else vistas.add(col);
    });
  };

  const acabar = () => {
    boton.hidden = true;
    nota.textContent = nota.dataset.lvFin || '';
  };

  // Devuelve true solo si ha añadido piezas de verdad. El vigía lo usa para
  // llevar la cuenta: si descontara por cada aviso, dos avisos seguidos
  // mientras aún se está cargando gastarían dos páginas de las tres
  // automáticas habiendo cargado una.
  const carga = async () => {
    if (cargando || !siguiente) return false;
    cargando = true;
    boton.disabled = true;
    const texto = boton.textContent;
    boton.textContent = '…';

    try {
      const r = await fetch(siguiente);
      if (!r.ok) throw new Error(r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');

      // Las piezas nuevas se añaden al final. No se toca lo que ya está: quien
      // esté a mitad de la página no debe notar ningún salto.
      // Los rótulos de colección que ya están puestos no se repiten.
      //
      // Cada hoja se genera sin saber nada de la anterior, así que una
      // colección que sigue en la hoja siguiente vuelve a sacar su rótulo. Al
      // recargar la página sola no se nota —son hojas distintas—, pero aquí se
      // van pegando una debajo de otra y el mismo nombre aparecía dos veces
      // separado por veinte piezas.
      doc.querySelectorAll('[data-lv-rejilla] > li').forEach((li) => rejilla.appendChild(li));
      quitaRotulosRepetidos();

      // La dirección de la barra cambia a la de la última página cargada. Es lo
      // que hace que el botón de atrás devuelva a este punto y no al principio:
      // después de veinte minutos bajando por un archivo, volver arriba del todo
      // es motivo para cerrar la pestaña.
      history.replaceState(null, '', siguiente);

      // Los números se ponen al día con los de la página recién cargada: si no,
      // seguirían marcando la primera cuando ya se va por la sexta.
      const numerosViejos = nav.querySelector('.lv-paginacion__numeros');
      const numerosNuevos = doc.querySelector('.lv-paginacion__numeros');
      if (numerosViejos && numerosNuevos) numerosViejos.replaceWith(numerosNuevos);

      siguiente = doc.querySelector('[data-lv-siguiente]')?.href || null;
      if (!siguiente) acabar();
      return true;
    } catch (e) {
      // Si falla, vuelven los enlaces de siempre: la página siguiente se
      // alcanza igual, solo que a mano.
      flechas.forEach((e) => { e.hidden = false; });
      caja.hidden = true;
      return false;
    } finally {
      cargando = false;
      boton.disabled = false;
      if (boton.textContent === '…') boton.textContent = texto;
    }
  };

  boton.addEventListener('click', carga);

  // --- Y hacia arriba ---
  //
  // La rejilla solo crecia hacia abajo. Si entrabas por un numero de pagina
  // —filtras por 2023, hay cinco paginas, saltas a la tercera— tenias cincuenta
  // piezas y nada encima: subir no daba nada. Ahora sube igual que baja.
  const arrancaSubida = () => {
    const cajaAntes = document.querySelector('[data-lv-antes]');
    const botonAntes = cajaAntes?.querySelector('[data-lv-antes-boton]');
    if (!cajaAntes || !botonAntes || cajaAntes.dataset.lvListo) return;
    cajaAntes.dataset.lvListo = '1';

    // Subir tambien tiene tope, el mismo que bajar. Si entras por la pagina 60
    // y subes sin parar, cada hoja son cincuenta piezas mas en la pagina: el
    // limite existe por lo mismo que al bajar.
    let subidasSolas = Number(nav.dataset.lvAuto || 0);

    const anclaDelNavegador =
      typeof CSS !== 'undefined' && CSS.supports && CSS.supports('overflow-anchor', 'auto');
    let anterior = nav.querySelector('[data-lv-anterior]')?.href || null;
    let subiendo = false;

    const cargaAntes = async () => {
      if (subiendo || !anterior) return false;
      subiendo = true;
      botonAntes.disabled = true;
      const texto = botonAntes.textContent;
      botonAntes.textContent = '…';

      try {
        const r = await fetch(anterior);
        if (!r.ok) throw new Error(r.status);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const nuevas = [...doc.querySelectorAll('[data-lv-rejilla] > li')];
        if (!nuevas.length) {
          anterior = null;
          cajaAntes.hidden = true;
          return false;
        }

        // Meter piezas por arriba empuja hacia abajo todo lo demas, y al
        // visitante se le va de los ojos lo que estaba mirando. Asi que se toma
        // como ancla la primera pieza que ya habia, se mide donde esta antes y
        // despues, y se corre el scroll esa misma distancia. Para quien mira, no
        // se ha movido nada: simplemente ahora hay mas arriba.
        //
        // Se mide el ancla y no el alto total de la pagina porque el alto puede
        // cambiar por otras razones mientras tanto.
        // El ancla NO puede ser un rotulo de coleccion. `quitaRotulosRepetidos`
        // borra los que se repiten, y si borra justo el que estabamos midiendo,
        // medirlo despues devuelve cero —esta desconectado— y la cuenta sale
        // mal: la pagina pegaba un salto de medio pantallazo. Se elige la
        // primera pieza, que esas no se borran nunca.
        const ancla = rejilla.querySelector('li:not([data-lv-coleccion])') || rejilla.firstElementChild;
        const antes = ancla.getBoundingClientRect().top;
        const trozo = document.createDocumentFragment();
        nuevas.forEach((li) => trozo.appendChild(li));
        rejilla.insertBefore(trozo, rejilla.firstElementChild);
        quitaRotulosRepetidos();
        // Solo donde el navegador no lo haga por su cuenta. Chrome y Firefox
        // tienen anclaje de scroll y corrigen esto solos; Safari no. Si
        // corrigieramos siempre, donde ya funciona saltaria el doble.
        if (!anclaDelNavegador && ancla.isConnected) {
          window.scrollBy(0, ancla.getBoundingClientRect().top - antes);
        }

        anterior = doc.querySelector('[data-lv-anterior]')?.href || null;
        if (!anterior) cajaAntes.hidden = true;
        return true;
      } catch (e) {
        // Si falla, vuelve el enlace de siempre: la pagina anterior se alcanza
        // igual, solo que a mano.
        cajaAntes.hidden = true;
        nav.querySelector('[data-lv-anterior]')?.removeAttribute('hidden');
        return false;
      } finally {
        subiendo = false;
        botonAntes.disabled = false;
        if (botonAntes.textContent === '…') botonAntes.textContent = texto;
      }
    };

    botonAntes.addEventListener('click', cargaAntes);

    // Y se carga sola al acercarse por arriba. No se desboca: cada hoja que entra
    // empuja el tirador muy por encima de la pantalla, asi que no vuelve a
    // dispararse hasta que el visitante sube otra vez.
    if ('IntersectionObserver' in window) {
      const vigiaArriba = new IntersectionObserver(
        (entradas) => {
          if (!entradas[0].isIntersecting || subidasSolas <= 0) return;
          cargaAntes().then((cargo) => {
            if (!cargo) return;
            subidasSolas -= 1;
            if (subidasSolas <= 0) vigiaArriba.disconnect();
          });
        },
        { rootMargin: '600px' }
      );
      vigiaArriba.observe(cajaAntes);
    }
  };

  // Se arranca ANTES de la salida de abajo. En la ultima pagina no hay
  // siguiente y el cargador de bajada se rinde ahi mismo; si la subida fuera
  // despues, no se montaria justo donde mas falta hace.
  arrancaSubida();

  if (!siguiente) {
    acabar();
    return;
  }

  // --- Las primeras, solas ---
  //
  // Se vigila el propio botón: cuando asoma por abajo, se carga otra página. El
  // margen hace que empiece a cargar antes de que llegue del todo, así que la
  // rejilla nunca se corta en seco.
  if (solasRestantes > 0 && 'IntersectionObserver' in window) {
    const vigia = new IntersectionObserver(
      (entradas) => {
        if (!entradas[0].isIntersecting || solasRestantes <= 0) return;
        carga().then((cargo) => {
          if (!cargo) return;
          solasRestantes -= 1;
          if (solasRestantes <= 0) vigia.disconnect();
        });
      },
      { rootMargin: '600px' }
    );
    vigia.observe(caja);
  }
};

lvArrancaMas();
document.addEventListener('lv:biblio:repintada', lvArrancaMas);
